import {Component, inject, Input} from '@angular/core';
import {NgClass} from '@angular/common';
import {FFAccordionComponent} from './ff-accordion.component';

/**
 * FFAccordion header component
 */
@Component({
    selector: 'app-ff-accordion-header',
    templateUrl: './ff-accordion-header.component.html',
    styleUrl: './ff-accordion-header.component.scss',
    imports: [NgClass]
})
export class FFAccordionHeaderComponent {
    protected container: FFAccordionComponent = inject(FFAccordionComponent, {skipSelf: true, host: true});

    // ===============================================================
    // ===============================================================

    @Input()
    public value?: string | number;
    @Input()
    public label?: string;

    // ===============================================================
    // ===============================================================

    /**
     * Activate this tab
     */
    public activate() {
        if (!this.value) return;

        if (this.container.value == this.value) this.container?.changeActiveValue(-1);
        else this.container?.changeActiveValue(this.value);
    }
}
